import { Module } from '../Module';
import { _review } from './functions/_review';

export class Review extends Module {
	initialize() {
		_review();
	}
}
